import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { urls } from "../urls";
import { defaultNotificationChore, defaultTransactionalChoreOverride } from "../defaultValues";
import { scheduleTypes, notificationChore_Status, notificationChoreType } from "../constants";

const GET_NOTIFICATIONCHORES = 'peptalkr/NotificationChores/GET_NOTIFICATIONCHORES';
const GET_NOTIFICATIONCHORES_SUCCESS = 'peptalkr/NotificationChores/GET_NOTIFICATIONCHORES_SUCCESS';
const GET_NOTIFICATIONCHORES_FAILURE = 'peptalkr/NotificationChores/GET_NOTIFICATIONCHORES_FAILURE';
const GET_NOTIFICATIONCHORE_SUCCESS = 'peptalkr/NotificationChores/GET_NOTIFICATIONCHORE_SUCCESS';

const ADD_NOTIFICATIONCHORE = 'peptalkr/NotificationChore/ADD_NOTIFICATIONCHORE';
const ADD_NOTIFICATIONCHORE_SUCCESS = 'peptalkr/NotificationChore/ADD_NOTIFICATIONCHORE_SUCCESS';
const ADD_NOTIFICATIONCHORE_FAILURE = 'peptalkr/NotificationChore/ADD_NOTIFICATIONCHORE_FAILURE';

const GET_NOTIFICATIONCHORE_HISTORY = 'peptalkr/NotificationChore/GET_NOTIFICATIONCHORE_HISTORY';
const GET_NOTIFICATIONCHORE_HISTORY_SUCCESS = 'peptalkr/NotificationChore/GET_NOTIFICATIONCHORE_HISTORY_SUCCESS';
const GET_NOTIFICATIONCHORE_HISTORY_FAILURE = 'peptalkr/NotificationChore/GET_NOTIFICATIONCHORE_HISTORY_FAILURE';

const DELETE_NOTIFICATIONCHORE = 'peptalkr/NotificationChore/DELETE_NOTIFICATIONCHORE';
const DELETE_NOTIFICATIONCHORE_SUCCESS = 'peptalkr/NotificationChore/DELETE_NOTIFICATIONCHORE_SUCCESS';
const DELETE_NOTIFICATIONCHORE_FAILURE = 'peptalkr/NotificationChore/DELETE_NOTIFICATIONCHORE_FAILURE';

const UPDATE_NOTIFICATIONCHORE = 'peptalkr/NotificationChore/UPDATE_NOTIFICATIONCHORE';
const UPDATE_NOTIFICATIONCHORE_SUCCESS = 'peptalkr/NotificationChore/UPDATE_NOTIFICATIONCHORE_SUCCESS';
const UPDATE_NOTIFICATIONCHORE_FAILURE = 'peptalkr/NotificationChore/UPDATE_NOTIFICATIONCHORE_FAILURE';

const RETRY_NOTIFICATIONCHORE = 'peptalkr/NotificationChore/RETRY_NOTIFICATIONCHORE';
const RETRY_NOTIFICATIONCHORE_SUCCESS = 'peptalkr/NotificationChore/RETRY_NOTIFICATIONCHORE_SUCCESS';
const RETRY_NOTIFICATIONCHORE_FAILURE = 'peptalkr/NotificationChore/RETRY_NOTIFICATIONCHORE_FAILURE';

export const requestNotificationChores = () => ({ type: GET_NOTIFICATIONCHORES });
export const receiveNotificationChores = (notificationchores, smsCredit, id, notificationChoreType, copy) => ({ type: GET_NOTIFICATIONCHORES_SUCCESS, notificationchores, smsCredit, id, notificationChoreType, copy });
export const receiveNotificationChoresFail = error => ({ type: GET_NOTIFICATIONCHORES_FAILURE, error });
export const receiveNotificationChore = (notificationchore) => ({ type: GET_NOTIFICATIONCHORE_SUCCESS, notificationchore });

export const addNotificationChore = () => ({ type: ADD_NOTIFICATIONCHORE });
export const addNotificationChoreSuccess = (notificationchore, notificationchores) => ({ type: ADD_NOTIFICATIONCHORE_SUCCESS, notificationchore, notificationchores });
export const addNotificationChoreFailure = error => ({ type: ADD_NOTIFICATIONCHORE_FAILURE, error });

export const getNotificationChoreHistory = () => ({ type: GET_NOTIFICATIONCHORE_HISTORY });
export const getNotificationChoreHistorySuccess = notificationchorehistory => ({ type: GET_NOTIFICATIONCHORE_HISTORY_SUCCESS, notificationchorehistory });
export const getNotificationChoreHistoryFailure = error => ({ type: GET_NOTIFICATIONCHORE_HISTORY_FAILURE, error });

export const deleteNotificationChore = () => ({ type: DELETE_NOTIFICATIONCHORE });
export const deleteNotificationChoreSuccess = id => ({ type: DELETE_NOTIFICATIONCHORE_SUCCESS, id });
export const deleteNotificationChoreFailure = error => ({ type: DELETE_NOTIFICATIONCHORE_FAILURE, error });

export const updateNotificationChore = () => ({ type: UPDATE_NOTIFICATIONCHORE });
export const updateNotificationChoreSuccess = id => ({ type: UPDATE_NOTIFICATIONCHORE_SUCCESS, id });
export const updateNotificationChoreFailure = error => ({ type: UPDATE_NOTIFICATIONCHORE_FAILURE, error });

export const retryNotificationChore = () => ({ type: RETRY_NOTIFICATIONCHORE });
export const retryNotificationChoreSuccess = id => ({ type: RETRY_NOTIFICATIONCHORE_SUCCESS, id });
export const retryNotificationChoreFailure = error => ({ type: RETRY_NOTIFICATIONCHORE_FAILURE, error });

export const fetchnotificationchores = (props) => (dispatch) => {
    const id = EVO.getParamsId(props);
    const notificationChoreType = props.notificationChoreType;
    const copy = props && props.match && props.match.path.indexOf('copy') > -1;

    if (id && id === 'new') {
        dispatch(receiveNotificationChore(defaultNC(notificationChoreType)))
    }
    else if (props && props.notificationchores) {
        dispatch(receiveNotificationChores(props.notificationchores, props.smsCredit, id, notificationChoreType, copy))
    }
    else {
        const authService = new AuthService();
        if (authService.isAuthenticated()) {
            dispatch(requestNotificationChores());
            EVO.fetch(urls.api.notificationchores.getAll)
                .then(response => {
                    dispatch(receiveNotificationChores(response.notificationchores, response.smsCredit, id, notificationChoreType, copy));
                })
                .catch(error => dispatch(receiveNotificationChoresFail(error)));
        }
    }
};

export const fetchnotificationchorehistory = (id, page) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(getNotificationChoreHistory());
        return EVO.fetch(urls.api.notificationchores.getHistory(id, page))
            .then(response => dispatch(getNotificationChoreHistorySuccess(response)))
            .catch(error => dispatch(getNotificationChoreHistoryFailure(error)));
    }
};

export const addItem = (item) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(addNotificationChore());
        return EVO.fetch(urls.api.notificationchores.add, item)
            .then(response => dispatch(addNotificationChoreSuccess(response.notificationchore, response.notificationchores)))
            .catch(error => dispatch(addNotificationChoreFailure(error)));
    }
};

export const setActive = (nc, active) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(updateNotificationChore());
        return EVO.fetch(urls.api.notificationchores.updateActive, { id: nc.id, active: active })
            .then(response => dispatch(updateNotificationChoreSuccess(nc)))
            .catch(error => dispatch(updateNotificationChoreFailure(error)));
    }
};

export const updateChore = (nc) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(updateNotificationChore());
        return EVO.fetch(urls.api.notificationchores.update, nc)
            .then(response => dispatch(updateNotificationChoreSuccess(nc)))
            .catch(error => dispatch(updateNotificationChoreFailure(error)));
    }
};

export const retryNC = (nc) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(retryNotificationChore());
        return EVO.fetch(urls.api.notificationchores.retry, { id: nc.id })
            .then(response => dispatch(retryNotificationChoreSuccess(nc)))
            .catch(error => dispatch(retryNotificationChoreFailure(error)));
    }
};

export const deleteItem = (id) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(deleteNotificationChore());
        return EVO.fetch(urls.api.notificationchores.delete, { id: id })
            .then(response => dispatch(deleteNotificationChoreSuccess(id)))
            .catch(error => dispatch(deleteNotificationChoreFailure(error)));
    }
};

const initialState = {
    notificationchores: null,
    notificationchore: defaultNotificationChore,
    notificationchorehistory: {},
    loading: true,
    smsCredit: 0,
    oneoffchores: [],
    recurringchores: [],
    attentionchores: [],
    activeLoading: false,
    deleteLoading: false,
    error: false
};

const defaultNC = (type) => {
    if (type && type === notificationChoreType.Email) {
        return { ...defaultNotificationChore, ...defaultTransactionalChoreOverride };
    }

    return defaultNotificationChore;
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONCHORES:
            draft.loading = true;
            return;
        case GET_NOTIFICATIONCHORES_SUCCESS:
            draft.loading = false;
            draft.notificationchores = action.notificationchores;
            draft.oneoffchores = action.notificationchores.filter(c => c.notificationType === notificationChoreType.Sms && c.scheduleTypeId === scheduleTypes.OneOff.value).sort((a, b) => (!a.sentDateTime || a.sentDateTime > b.sentDateTime) ? -1 : 1);
            draft.recurringchores = action.notificationchores.filter(c => c.notificationType === notificationChoreType.Sms && c.scheduleTypeId === scheduleTypes.Recurring.value).sort((a, b) => a.name > b.name ? 1 : -1);
            draft.transactionalChores = action.notificationchores.filter(c => c.notificationType === notificationChoreType.Email && c.scheduleTypeId === scheduleTypes.Recurring.value).sort((a, b) => a.name > b.name ? 1 : -1);
            draft.transactionalOneOffChores = action.notificationchores.filter(c => c.notificationType === notificationChoreType.Email && c.scheduleTypeId === scheduleTypes.OneOff.value).sort((a, b) => a.name > b.name ? 1 : -1);
            draft.attentionchores = action.notificationchores.filter(nc => nc.status === notificationChore_Status.InsufficientCredits);
            const defaultVal = defaultNC(action.notificationChoreType);
            draft.notificationchore = action.id ? EVO.getDetailsItemById(action.notificationchores, action.id, defaultVal) : defaultVal;
            draft.smsCredit = action.smsCredit;
            if (action.copy) {
                draft.notificationchore.name = draft.notificationchore.name + ' - Duplicate';
                draft.notificationchore.id = null;
            }
            return;
        case GET_NOTIFICATIONCHORES_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        case GET_NOTIFICATIONCHORE_HISTORY:
            draft.loading = true;
            return;
        case GET_NOTIFICATIONCHORE_HISTORY_SUCCESS:
            draft.loading = false;
            draft.notificationchorehistory = action.notificationchorehistory;
            const defaultHistoryVal = defaultNC(action.notificationChoreType);
            draft.notificationchore = Object.assign(EVO.clone(defaultHistoryVal), action.notificationchorehistory.chore);
            return;
        case GET_NOTIFICATIONCHORE_HISTORY_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            draft.notificationchorehistory = [];
            return;
        case UPDATE_NOTIFICATIONCHORE:
            draft.activeLoading = true;
            return;
        case UPDATE_NOTIFICATIONCHORE_SUCCESS:
            draft.activeLoading = false;

            if (action.notificationchore) {
                draft.notificationchore = action.notificationchore;
            }

            if (action.notificationchores) {
                draft.notificationchores = action.notificationchores;
            }

            return;
        case UPDATE_NOTIFICATIONCHORE_FAILURE:
            //draft.activeLoading = false;
            draft.error = action.error;
            return;
        case RETRY_NOTIFICATIONCHORE:
            //draft.activeLoading = true;
            return;
        case RETRY_NOTIFICATIONCHORE_SUCCESS:
            //draft.activeLoading = false;
            return;
        case RETRY_NOTIFICATIONCHORE_FAILURE:
            draft.activeLoading = false;
            draft.error = action.error;
            return;
        case DELETE_NOTIFICATIONCHORE:
            draft.deleteLoading = true;
            return;
        case DELETE_NOTIFICATIONCHORE_SUCCESS:
            draft.deleteLoading = false;
            return;
        case DELETE_NOTIFICATIONCHORE_FAILURE:
            draft.deleteLoading = false;
            draft.error = action.error;
            return;
        case GET_NOTIFICATIONCHORE_SUCCESS:
            draft.loading = false;
            draft.notificationchore = action.notificationchore;
            return;
        case ADD_NOTIFICATIONCHORE:
            // nothing to do.. Formik handles it
            return;
        case ADD_NOTIFICATIONCHORE_SUCCESS:
            draft.notificationchore = action.notificationchore;
            if (action.notificationchores) {
                draft.notificationchores = action.notificationchores;
            }
            return;
        case ADD_NOTIFICATIONCHORE_FAILURE:
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/notificationchores.js